import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "./posts.css";
import { NavLink } from "react-router-dom";
import S3Upload from "../S3Media/S3Upload";
import $ from "jquery";
import MediaRender from "../S3Media/MediaRender";

const AddPost = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [languages, setlanguages] = useState([]);
  const [ideas, setideas] = useState([]);
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });
  const [media, setMedia] = useState([]);
  const [post, setPost] = useState({
    language: user.language,
    title: "",
    description: "",
    medias: [],
    featured: "",
    idea: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPost((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const wordCount = (e) => {
    let maxwords = 400;
    if (user.language === 1 || user.language === 8) {
      maxwords = 400;
    } else {
      maxwords = 250;
    }

    let desc = e.target.value.trim();
    var words = 0;

    if (desc !== "") {
      words = desc.split(" ").length;
    }
    let wordsLeft = maxwords - words;
    if (words > maxwords) {
      //var trimmed = desc.split(" ", maxwords).join(" ");
      //$('#description').val(trimmed + " ");
    } else {
      $("#word_left").removeClass("alert-danger");
      if (wordsLeft <= maxwords / 10) {
        $("#word_left").addClass("alert-danger");
      }
    }
    $("#word_left").html(wordsLeft);
  };

  const attachedMedia = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let medias = post.medias;
    if (e.target.checked) {
      medias.push(value);
    } else {
      medias.pop(value);
    }

    setPost((prevState) => {
      return {
        ...prevState,
        [name]: medias,
      };
    });
  };

  const attachedFeature = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (e.target.checked) {
      setPost((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });
    }
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const savePost = async (e) => {
    e.preventDefault();
    let error = false;
    //console.log(post);
    //return;
    if (post.title === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter post title.",
        };
      });
      return;
    }
    if (post.description === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter post description.",
        };
      });
      return;
    }

    if (user.language === 1 || user.language === 8) {
      if (post.medias.length === 0) {
        error = true;
        setMessage(() => {
          return {
            type: "danger",
            message: "Please select atleadst 1 media.",
          };
        });
        return;
      }

      if (post.medias.length > 0 && post.featured === "") {
        error = true;
        setMessage(() => {
          return {
            type: "danger",
            message: "Please choose feature media.",
          };
        });
        return;
      }
    }

    if (post.idea === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please select Idea.",
        };
      });
      return;
    }
    if (post.idea === "0") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please select Idea.",
        };
      });
      return;
    }
    let intWordLeft = $("#word_left").html();
    if (intWordLeft === "") {
      intWordLeft = 0;
    }
    if (parseInt(intWordLeft) > 0) {
      setMessage(() => {
        let maxwords = 400;
        if (user.language === 1 || user.language === 8) {
          maxwords = 400;
        } else {
          maxwords = 250;
        }
        return {
          type: "danger",
          message: "Please enter atleast " + maxwords + " words.",
        };
      });
      return;
    }

    console.log(post.medias.length, post.featured, post.idea, error);

    if (!error) {
      await axios
        .post(
          localStorage.getItem("basurl") + "/posts",
          {
            language: post.language,
            title: post.title,
            description: post.description,
            medias: post.medias,
            idea: post.idea,
            featured: post.featured,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
          document.getElementsByName("medias").forEach(function (box) {
            box.checked = false;
          });
          document.getElementsByName("featured").forEach(function (box) {
            box.checked = false;
          });
          setPost({ title: "", description: "", medias: [] });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };
  const refreshMedia = async (e) => {
    loadMedia();
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const getLanguage = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/languages")
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  const getIdea = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/idea-list", {
          headers: { "mojo-access-tokens": user.token },
        })
        .then((response) => {
          setideas(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  const loadMedia = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/media-list", {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          setMedia(() => {
            return response.data;
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getIdea();
    getLanguage();
    loadMedia();
  }, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}
        {/* {dictaPhone()} */}
        <div className="row">
          <label className="col-sm-3 form-control-label">
            Idea: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-t-5 mg-sm-t-0">
            <select
              id="signup-ideas"
              name="idea"
              onFocus={resetMessage}
              onChange={handleChange}
              placeholder="Please choose your idea"
              className="form-control"
              value={post.idea_id}
              defaultValue={0}
            >
              {ideas.map((idea) => (
                <option
                  key={`idea` + idea.id}
                  value={idea.id}
                  selected={idea.id === post.idea_id ? true : false}
                >
                  {idea.description}
                </option>
              ))}
            </select>
          </div>

          <label className="col-sm-3 form-control-label">
            Language: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-t-5 mg-sm-t-0">
            <select
              id="signup-language"
              name="language"
              onFocus={resetMessage}
              onChange={handleChange}
              placeholder="Please choose your language"
              className="form-control"
              value={post.language}
              defaultValue={0}
            >
              {languages.map((lang) => (
                <option
                  key={`lang` + lang.id}
                  value={lang.id}
                  selected={lang.id === post.language ? true : false}
                >
                  {lang.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Title: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <input
              name="title"
              type="text"
              className="form-control"
              placeholder="Enter post title"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={post.title}
            />
          </div>
        </div>
        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Description: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <textarea
              id="description"
              name="description"
              rows={8}
              onKeyUp={wordCount}
              className="form-control"
              placeholder="Enter post description"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={post.description}
            />
            Words left:{" "}
            <b>
              <span id="word_left"></span>
            </b>
          </div>
        </div>
        <div className="form-layout-footer mg-t-30 tx-right">
          <NavLink to="/posts"> My Posts </NavLink> &nbsp; &nbsp; &nbsp;
          <button
            onClick={savePost}
            className="btn btn-info"
            style={{ cursor: "pointer" }}
          >
            Save
          </button>
          &nbsp;&nbsp;
        </div>

        {user.language === 1 || user.language === 8 ? (
          <>
            <div className="card shadow-base bd-0 mg-t-10">
              <b>&nbsp;Upload Media:</b>
              <S3Upload pagetitle="Media" />
            </div>
            <div className="row mg-t-10">
              <div className="col-sm-4">
                <b>Attach Media:</b>
                <button
                  onClick={refreshMedia}
                  className="pointer ft-right btn-xs alert-info"
                >
                  Refresh
                </button>
              </div>

              <div className="col-sm-8 mg-sm-t-0">
                <div className="bd rounded table-responsive">
                  <table className="table table-responsive table-bordered">
                    <thead>
                      <tr>
                        <th></th>
                        <th width="60px">Media</th>
                        <th>Media Name</th>
                        <th>Featured</th>
                      </tr>
                    </thead>
                    <tbody>
                      {media.length ? (
                        media.map((item) => (
                          <tr key={item.id}>
                            <td
                              className="valign-middle"
                              onClick={attachedMedia}
                              name="medias"
                              value={item.id}
                              style={{ padding: "0.30rem" }}
                            >
                              <input
                                className="pointer"
                                name="medias"
                                type="checkbox"
                                value={item.id}
                              />
                            </td>
                            <td
                              className="valign-middle"
                              style={{ padding: "0.30rem" }}
                            >
                              {<MediaRender data={item} rclass="thumbnail" />}
                            </td>
                            <td
                              className="valign-middle tx-center"
                              style={{ padding: "0.30rem" }}
                            >
                              <span className="d-block">
                                {item.media_title}
                              </span>
                              <span className="tx-success d-block">
                                <Moment date={item.created_at1} local fromNow />
                              </span>
                            </td>
                            <td className="tx-center">
                              <span>
                                {item.file_type === "image/png" ||
                                item.file_type === "image/jpeg" ? (
                                  <input
                                    className="pointer"
                                    type="radio"
                                    name="featured"
                                    value={item.id}
                                    onClick={attachedFeature}
                                  />
                                ) : (
                                  <> - </>
                                )}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="tx-center">
                            You have not uploaded any file yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AddPost;
